// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_ProductFiscalSalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/product_fiscal/salvar
 *
 * Returns the persisted row (create or update).
 */
import type { So_ProductFiscalRow } from './So_ProductFiscalRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_ProductFiscalSalvarResponseDados = So_ProductFiscalRow;

export type So_ProductFiscalSalvarResponse = ApiResponse<So_ProductFiscalSalvarResponseDados>;

registerResponseContract('So_ProductFiscalSalvarResponse', {
  so_product_fiscal_id:                 { type: 'number',  required: true },
  so_product_fiscal_product_id:         { type: 'number',  required: true },
  so_product_fiscal_franchise_id:       { type: 'number',  required: false },
  so_product_fiscal_ncm:                { type: 'string',  required: false },
  so_product_fiscal_cest:               { type: 'string',  required: false },
  so_product_fiscal_cfop_dentro_uf:     { type: 'string',  required: false },
  so_product_fiscal_cfop_fora_uf:       { type: 'string',  required: false },
  so_product_fiscal_cst:                { type: 'string',  required: false },
  so_product_fiscal_csosn:              { type: 'string',  required: false },
  so_product_fiscal_origem:             { type: 'number',  required: false },
  so_product_fiscal_unidade_tributavel: { type: 'string',  required: false },
})
